import React from 'react';

const RateHistoryModal = ({ history, onClose }) => {
    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
        }}>
            <div style={{
                backgroundColor: 'white', padding: '25px', borderRadius: '8px', 
                width: '750px', maxHeight: '80vh', overflowY: 'auto', boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
            }}>
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'20px'}}>
                    <h3 style={{margin:0, color:'#2c3e50'}}>📜 Historique des Taux de Gestion</h3>
                    <button onClick={onClose} style={{border:'none', background:'none', fontSize:'1.5rem', cursor:'pointer'}}>×</button>
                </div>

                <table style={{width: '100%', borderCollapse: 'collapse'}}>
                    <thead>
                        <tr style={{background: '#f8f9fa', color: '#7f8c8d', textAlign: 'left', borderBottom: '2px solid #eee'}}>
                            <th style={{padding: '12px'}}>Période</th>
                            <th style={{padding: '12px'}}>Taux</th>
                            <th style={{padding: '12px'}}>Modifié par</th>
                            <th style={{padding: '12px'}}>Commentaire</th>
                            <th style={{padding: '12px'}}>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {history.length === 0 ? (
                            <tr><td colSpan="5" style={{padding:'20px', textAlign:'center', color:'#999'}}>Aucun historique disponible.</td></tr>
                        ) : (
                            history.map((item, idx) => (
                                <tr key={idx} style={{borderBottom: '1px solid #eee'}}>
                                    <td style={{padding: '12px', fontWeight: 'bold'}}>
                                        {item.month < 10 ? `0${item.month}` : item.month}/{item.year}
                                    </td>
                                    <td style={{padding: '12px', color: '#e67e22', fontWeight: 'bold'}}>
                                        {item.rate}%
                                    </td>
                                    <td style={{padding: '12px', fontSize:'0.9rem', color:'#34495e'}}>
                                        {item.modified_by}
                                    </td>
                                    <td style={{padding: '12px', fontSize:'0.9rem', fontStyle:'italic', color:'#7f8c8d'}}>
                                        {item.comment || '-'}
                                    </td>
                                    <td style={{padding: '12px', fontSize:'0.8rem', color:'#95a5a6'}}>
                                        {item.updated_at}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
                
                <div style={{marginTop:'20px', textAlign:'right'}}>
                    <button onClick={onClose} style={{padding:'8px 20px', background:'#3498db', color:'white', border:'none', borderRadius:'4px', cursor:'pointer'}}>Fermer</button>
                </div>
            </div>
        </div>
    );
};

export default RateHistoryModal;